import { render, staticRenderFns } from "./PublisherSetupTabBigDealCosts.vue?vue&type=template&id=6dcac21a&scoped=true&"
import script from "./PublisherSetupTabBigDealCosts.vue?vue&type=script&lang=js&"
export * from "./PublisherSetupTabBigDealCosts.vue?vue&type=script&lang=js&"
import style0 from "./PublisherSetupTabBigDealCosts.vue?vue&type=style&index=0&id=6dcac21a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcac21a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VDialog,VIcon,VListItem,VListItemAction,VListItemContent,VListItemIcon,VSpacer,VTextField})
